import type { NextPage } from "next";
import AnalyticsFormScreen from "@components/Screens/Analytics/AnalyticsFormScreen/AnalyticsFormScreen";
import Template from "@app/Template/Template";
import { PROJECT_NAME } from "@shared/config/GlobalText";
import { configApi } from "@shared/lib/configApi";
import { RouterConfig } from "@shared/lib/routerConfig";
import { CustomHead, DEFAULT_OG_IMAGE } from "@shared/ui/CustomHead";

const EstimatePage: NextPage = () => {
    const title = `Оценка стоимости автомобиля онлайн - узнайте актуальную цену - ${PROJECT_NAME}`;
    const description = `Проведите независимую оценку стоимости авто онлайн. Получите независимую рыночную стоимость для продажи, страхования или после ДТП.`;
    const canonicalUrl = `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.ANALYTICS}`;

    return (
        <Template bgColor="blue">
            <CustomHead
                title={title}
                description={description}
                robots={"index,follow"}
                canonical={canonicalUrl}
                openGraph={{
                    title: title,
                    description: description,
                    url: canonicalUrl,
                    type: "website",
                    image: {
                        url: DEFAULT_OG_IMAGE,
                        alt: title
                    }
                }}
            />
            <AnalyticsFormScreen />
        </Template>
    );
};

export default EstimatePage;